function formatDateString(dateData: string) {
  let date = new Date(dateData);
  let y = date.getFullYear();
  let m: any = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d: any = date.getDate();
  d = d < 10 ? "0" + d : d;
  return y + "-" + m + "-" + d;
}
export { formatDateString };
